import { getChoseong } from "es-hangul";

// keepNonHangul을 빼면 es-hangul이 영문·숫자를 지운다. 그러면 "UHR"·"350" 같은 검색어가
// 빈 문자열이 되어 모든 항목과 일치해버리므로(=검색이 무력화) 반드시 유지시킨다.
const toChoseong = (value) =>
  getChoseong(String(value ?? "").toLowerCase(), { keepNonHangul: true });

// 한글 이름을 초성으로도 찾을 수 있게 한다. 상품명·회원명 검색이 모두 이 함수를 쓴다.
export const matchesChoseong = (text, searchTerm) =>
  toChoseong(text).includes(toChoseong(searchTerm));
